module.exports = __webpack_public_path__ + "static/media/down-arrow-theme.7cd54b12.svg";